import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'my-pais',
  template: require('./pais.component.html')
})
export class PaisComponent implements OnInit {

  constructor(private _activatedRoute: ActivatedRoute, private _router: Router) {
    this._activatedRoute.params.subscribe(params => {
      let paisConfiguration = {};
      switch (params['id']) {
        case 've':
          paisConfiguration = {
            idPais: 1,
            nombre: "Venezuela",
            url: "ve",
            correo: "venezuela@venezuela",
            moneda: "Bolivar",
            codigoInternacional: "VEF",
            simbolo: "Bs",
            zonaHoraria: "American/Pacific",
            cambioDolar: 1,
            direccion: "Dirección Venezuela",
            rif: "v-1564654",
            idioma: "es"
          };
          break;
        case 'cl':
          paisConfiguration = {
            idPais: 2,
            nombre: "Chile",
            url: "cl",
            correo: "chile@grupojrca.com",
            moneda: "Peso Chileno",
            codigoInternacional: "CLP",
            simbolo: "$",
            zonaHoraria: "American/Pacific",
            cambioDolar: 1,
            direccion: "Dirección Chile",
            rif: "v-1564654",
            idioma: "es"
          };
          break;
        default:
          paisConfiguration = {
            idPais: 1,
            nombre: "Venezuela",
            url: "ve",
            correo: "venezuela@venezuela",
            moneda: "Bolivar",
            codigoInternacional: "VEF",
            simbolo: "Bs",
            zonaHoraria: "American/Pacific",
            cambioDolar: 1,
            direccion: "Dirección Venezuela",
            rif: "v-1564654",
            idioma: "es"
          };
      }
      localStorage.removeItem('pais');
      localStorage.setItem('pais', JSON.stringify(paisConfiguration));
      this._router.navigateByUrl('/');
      location.reload();
    })
  }

  ngOnInit() {
    console.log('Hello About');
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/pais/pais.component.ts